// extracted by mini-css-extract-plugin
var _1 = "webpack-concepts-Extraction-Compare-CompareButton-CompareButton-module__button webpack-concepts-Extraction-Compare-ComparisonTable-ComparisonTable-module__paddedCell webpack-concepts-Extraction-Compare-ComparisonTable-ComparisonTable-module__reviewer";
var _2 = "webpack-concepts-Extraction-Compare-CompareButton-CompareButton-module__consensus";
var _3 = "webpack-concepts-Extraction-Compare-CompareButton-CompareButton-module__resolved";
export { _1 as "button", _2 as "consensus", _3 as "resolved" }
